const comments_en = {
  title: "comments",
  publish_label: "Post a comment",
  publish_button: "Post comment",
  unlogged: "Log in to comment",
  empty: "No comments yet",
};
export default comments_en;
